<div class="ai-agent-composer" [class.ai-agent-composer--sending]="sending()">
  <textarea
    #textarea
    class="ai-agent-composer__input"
    id="ai-agent-composer-input"
    rows="2"
    [formControl]="messageControl"
    [maxlength]="messageMaxLength"
    [attr.aria-label]="messageLabel"
    placeholder="Type a message…"
    i18n-placeholder="@@AI_AGENT_COMPOSER_PLACEHOLDER"
    (keydown.enter)="onEnter($event)"
  ></textarea>
  <sim-tooltip class="ai-agent-composer__send" [tooltip]="sendLabel" [focusable]="false">
    <button
      type="button"
      id="ai-agent-composer-send"
      class="ai-agent-composer__send-button"
      [class.ai-agent-composer__send-button--sending]="sending()"
      [attr.aria-label]="sendLabel"
      [attr.aria-busy]="sending()"
      [disabled]="!canSend()"
      (click)="submit()"
    >
      @if (sending()) {
        <sim-spinner class="ai-agent-composer__spinner" [diameter]="18" [strokeWidth]="2" />
      } @else {
        <sim-icon icon="arrow_upward" [sizeInPx]="16" />
      }
    </button>
  </sim-tooltip>
</div>
